import { render, staticRenderFns } from "./HelpDropdown.vue?vue&type=template&id=133cd216&"
import script from "./HelpDropdown.vue?vue&type=script&lang=js&"
export * from "./HelpDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HelpDropdown.vue?vue&type=style&index=0&id=133cd216&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports